export default {"src":"/evde-internet/_next/static/media/loadingGif.be75b91c.gif","height":500,"width":500};